/* tslint:disable */
/* eslint-disable */
/**
 * Europrocurement Api Siren
 * API de récupération d\'information Siren
 *
 * The version of the OpenAPI document: 2.3.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 
 * @export
 * @interface ActiviteJsonldRead
 */
export interface ActiviteJsonldRead {
    /**
     * 
     * @type {ActiviteJsonldReadContext}
     * @memberof ActiviteJsonldRead
     */
    '@context'?: ActiviteJsonldReadContext;
    /**
     * 
     * @type {string}
     * @memberof ActiviteJsonldRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ActiviteJsonldRead
     */
    '@type'?: string;
    /**
     * Get the value of categoryCode
     * @type {string}
     * @memberof ActiviteJsonldRead
     */
    'categoryCode'?: string;
    /**
     * Get the value of exerciceActivite
     * @type {string}
     * @memberof ActiviteJsonldRead
     */
    'exerciceActivite'?: string;
    /**
     * Get the value of formeExercice
     * @type {string}
     * @memberof ActiviteJsonldRead
     */
    'formeExercice'?: string;
    /**
     * Get the value of formeExerciceRef
     * @type {number}
     * @memberof ActiviteJsonldRead
     */
    'formeExerciceRef'?: number;
    /**
     * Get the value of formeExerciceRefLibelle
     * @type {string}
     * @memberof ActiviteJsonldRead
     */
    'formeExerciceRefLibelle'?: string;
    /**
     * Get the value of descriptionDetaillee
     * @type {string}
     * @memberof ActiviteJsonldRead
     */
    'descriptionDetaillee'?: string;
    /**
     * Get the value of categorisationActivite1
     * @type {string}
     * @memberof ActiviteJsonldRead
     */
    'categorisationActivite1'?: string;
    /**
     * Get the value of categorisationActivite2
     * @type {string}
     * @memberof ActiviteJsonldRead
     */
    'categorisationActivite2'?: string;
    /**
     * Get the value of categorisationActivite3
     * @type {string}
     * @memberof ActiviteJsonldRead
     */
    'categorisationActivite3'?: string;
    /**
     * Get the value of indicateurNonSedentaire
     * @type {boolean}
     * @memberof ActiviteJsonldRead
     */
    'indicateurNonSedentaire'?: boolean;
    /**
     * Get the value of codeApe
     * @type {string}
     * @memberof ActiviteJsonldRead
     */
    'codeApe'?: string;
    /**
     * Get the value of dateDebut
     * @type {string}
     * @memberof ActiviteJsonldRead
     */
    'dateDebut'?: string;
    /**
     * Get the value of dateFin
     * @type {string}
     * @memberof ActiviteJsonldRead
     */
    'dateFin'?: string;
    /**
     * Get the value of rolePrincipalPourEntreprise
     * @type {boolean}
     * @memberof ActiviteJsonldRead
     */
    'rolePrincipalPourEntreprise'?: boolean;
    /**
     * Get the value of indicateurActiviteeApe
     * @type {boolean}
     * @memberof ActiviteJsonldRead
     */
    'indicateurActiviteeApe'?: boolean;
    /**
     * Get the value of indicateurArtisteAuteur
     * @type {boolean}
     * @memberof ActiviteJsonldRead
     */
    'indicateurArtisteAuteur'?: boolean;
    /**
     * Get the value of indicateurMarinProfessionnel
     * @type {boolean}
     * @memberof ActiviteJsonldRead
     */
    'indicateurMarinProfessionnel'?: boolean;
    /**
     * Get the value of indicateurPrincipal
     * @type {boolean}
     * @memberof ActiviteJsonldRead
     */
    'indicateurPrincipal'?: boolean;
    /**
     * Get the value of activiteRattacheeEirl
     * @type {boolean}
     * @memberof ActiviteJsonldRead
     */
    'activiteRattacheeEirl'?: boolean;
    /**
     * Get the value of activiteId
     * @type {string}
     * @memberof ActiviteJsonldRead
     */
    'activiteId'?: string;
    /**
     * Get the value of codeAprm
     * @type {string}
     * @memberof ActiviteJsonldRead
     */
    'codeAprm'?: string;
    /**
     * Get the value of precisionActivite
     * @type {string}
     * @memberof ActiviteJsonldRead
     */
    'precisionActivite'?: string;
}
/**
 * @type ActiviteJsonldReadContext
 * @export
 */
export type ActiviteJsonldReadContext = ActiviteJsonldReadContextOneOf | string;

/**
 * 
 * @export
 * @interface ActiviteJsonldReadContextOneOf
 */
export interface ActiviteJsonldReadContextOneOf {
    [key: string]: any;

    /**
     * 
     * @type {string}
     * @memberof ActiviteJsonldReadContextOneOf
     */
    '@vocab': string;
    /**
     * 
     * @type {string}
     * @memberof ActiviteJsonldReadContextOneOf
     */
    'hydra': ActiviteJsonldReadContextOneOfHydraEnum;
}

export const ActiviteJsonldReadContextOneOfHydraEnum = {
    HttpWwwW3OrgNsHydraCore: 'http://www.w3.org/ns/hydra/core#'
} as const;

export type ActiviteJsonldReadContextOneOfHydraEnum = typeof ActiviteJsonldReadContextOneOfHydraEnum[keyof typeof ActiviteJsonldReadContextOneOfHydraEnum];

/**
 * 
 * @export
 * @interface ActiviteRead
 */
export interface ActiviteRead {
    /**
     * Get the value of categoryCode
     * @type {string}
     * @memberof ActiviteRead
     */
    'categoryCode'?: string;
    /**
     * Get the value of exerciceActivite
     * @type {string}
     * @memberof ActiviteRead
     */
    'exerciceActivite'?: string;
    /**
     * Get the value of formeExercice
     * @type {string}
     * @memberof ActiviteRead
     */
    'formeExercice'?: string;
    /**
     * Get the value of formeExerciceRef
     * @type {number}
     * @memberof ActiviteRead
     */
    'formeExerciceRef'?: number;
    /**
     * Get the value of formeExerciceRefLibelle
     * @type {string}
     * @memberof ActiviteRead
     */
    'formeExerciceRefLibelle'?: string;
    /**
     * Get the value of descriptionDetaillee
     * @type {string}
     * @memberof ActiviteRead
     */
    'descriptionDetaillee'?: string;
    /**
     * Get the value of categorisationActivite1
     * @type {string}
     * @memberof ActiviteRead
     */
    'categorisationActivite1'?: string;
    /**
     * Get the value of categorisationActivite2
     * @type {string}
     * @memberof ActiviteRead
     */
    'categorisationActivite2'?: string;
    /**
     * Get the value of categorisationActivite3
     * @type {string}
     * @memberof ActiviteRead
     */
    'categorisationActivite3'?: string;
    /**
     * Get the value of indicateurNonSedentaire
     * @type {boolean}
     * @memberof ActiviteRead
     */
    'indicateurNonSedentaire'?: boolean;
    /**
     * Get the value of codeApe
     * @type {string}
     * @memberof ActiviteRead
     */
    'codeApe'?: string;
    /**
     * Get the value of dateDebut
     * @type {string}
     * @memberof ActiviteRead
     */
    'dateDebut'?: string;
    /**
     * Get the value of dateFin
     * @type {string}
     * @memberof ActiviteRead
     */
    'dateFin'?: string;
    /**
     * Get the value of rolePrincipalPourEntreprise
     * @type {boolean}
     * @memberof ActiviteRead
     */
    'rolePrincipalPourEntreprise'?: boolean;
    /**
     * Get the value of indicateurActiviteeApe
     * @type {boolean}
     * @memberof ActiviteRead
     */
    'indicateurActiviteeApe'?: boolean;
    /**
     * Get the value of indicateurArtisteAuteur
     * @type {boolean}
     * @memberof ActiviteRead
     */
    'indicateurArtisteAuteur'?: boolean;
    /**
     * Get the value of indicateurMarinProfessionnel
     * @type {boolean}
     * @memberof ActiviteRead
     */
    'indicateurMarinProfessionnel'?: boolean;
    /**
     * Get the value of indicateurPrincipal
     * @type {boolean}
     * @memberof ActiviteRead
     */
    'indicateurPrincipal'?: boolean;
    /**
     * Get the value of activiteRattacheeEirl
     * @type {boolean}
     * @memberof ActiviteRead
     */
    'activiteRattacheeEirl'?: boolean;
    /**
     * Get the value of activiteId
     * @type {string}
     * @memberof ActiviteRead
     */
    'activiteId'?: string;
    /**
     * Get the value of codeAprm
     * @type {string}
     * @memberof ActiviteRead
     */
    'codeAprm'?: string;
    /**
     * Get the value of precisionActivite
     * @type {string}
     * @memberof ActiviteRead
     */
    'precisionActivite'?: string;
}
/**
 * 
 * @export
 * @interface ApiRcsSirenGet400Response
 */
export interface ApiRcsSirenGet400Response {
    /**
     * 
     * @type {string}
     * @memberof ApiRcsSirenGet400Response
     */
    'error'?: string;
}
/**
 * 
 * @export
 * @interface ApiRcsSirenGet401Response
 */
export interface ApiRcsSirenGet401Response {
    /**
     * 
     * @type {string}
     * @memberof ApiRcsSirenGet401Response
     */
    'message'?: string;
}
/**
 * 
 * @export
 * @interface ApiRcsSirenGet403Response
 */
export interface ApiRcsSirenGet403Response {
    /**
     * 
     * @type {string}
     * @memberof ApiRcsSirenGet403Response
     */
    'error'?: string;
    /**
     * 
     * @type {ApiRcsSirenGet403ResponseException}
     * @memberof ApiRcsSirenGet403Response
     */
    'exception'?: ApiRcsSirenGet403ResponseException;
}
/**
 * 
 * @export
 * @interface ApiRcsSirenGet403ResponseException
 */
export interface ApiRcsSirenGet403ResponseException {
    /**
     * 
     * @type {string}
     * @memberof ApiRcsSirenGet403ResponseException
     */
    'message'?: string;
    /**
     * 
     * @type {number}
     * @memberof ApiRcsSirenGet403ResponseException
     */
    'code'?: number;
}
/**
 * 
 * @export
 * @interface ApiRcsSirenGet404Response
 */
export interface ApiRcsSirenGet404Response {
    /**
     * 
     * @type {string}
     * @memberof ApiRcsSirenGet404Response
     */
    'error'?: string;
    /**
     * 
     * @type {ApiRcsSirenGet404ResponseException}
     * @memberof ApiRcsSirenGet404Response
     */
    'exception'?: ApiRcsSirenGet404ResponseException;
}
/**
 * 
 * @export
 * @interface ApiRcsSirenGet404ResponseException
 */
export interface ApiRcsSirenGet404ResponseException {
    /**
     * 
     * @type {string}
     * @memberof ApiRcsSirenGet404ResponseException
     */
    'message'?: string;
    /**
     * 
     * @type {number}
     * @memberof ApiRcsSirenGet404ResponseException
     */
    'code'?: number;
}
/**
 * 
 * @export
 * @interface ApiRcsSirenGet503Response
 */
export interface ApiRcsSirenGet503Response {
    /**
     * 
     * @type {string}
     * @memberof ApiRcsSirenGet503Response
     */
    'error'?: string;
    /**
     * 
     * @type {ApiRcsSirenGet503ResponseException}
     * @memberof ApiRcsSirenGet503Response
     */
    'exception'?: ApiRcsSirenGet503ResponseException;
}
/**
 * 
 * @export
 * @interface ApiRcsSirenGet503ResponseException
 */
export interface ApiRcsSirenGet503ResponseException {
    /**
     * 
     * @type {string}
     * @memberof ApiRcsSirenGet503ResponseException
     */
    'message'?: string;
    /**
     * 
     * @type {number}
     * @memberof ApiRcsSirenGet503ResponseException
     */
    'code'?: number;
}
/**
 * 
 * @export
 * @interface ComparaisonKbisRne
 */
export interface ComparaisonKbisRne {
    /**
     * 
     * @type {string}
     * @memberof ComparaisonKbisRne
     */
    'siren': string;
}
/**
 * 
 * @export
 * @interface ComparaisonKbisRneJsonld
 */
export interface ComparaisonKbisRneJsonld {
    /**
     * 
     * @type {ActiviteJsonldReadContext}
     * @memberof ComparaisonKbisRneJsonld
     */
    '@context'?: ActiviteJsonldReadContext;
    /**
     * 
     * @type {string}
     * @memberof ComparaisonKbisRneJsonld
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ComparaisonKbisRneJsonld
     */
    '@type'?: string;
    /**
     * 
     * @type {string}
     * @memberof ComparaisonKbisRneJsonld
     */
    'siren': string;
}
/**
 * 
 * @export
 * @interface CompositionJsonldRead
 */
export interface CompositionJsonldRead {
    /**
     * 
     * @type {ActiviteJsonldReadContext}
     * @memberof CompositionJsonldRead
     */
    '@context'?: ActiviteJsonldReadContext;
    /**
     * 
     * @type {string}
     * @memberof CompositionJsonldRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CompositionJsonldRead
     */
    '@type'?: string;
    /**
     * Get the value of beneficiaireId
     * @type {string}
     * @memberof CompositionJsonldRead
     */
    'beneficiaireId'?: string;
    /**
     * Get the value of representantId
     * @type {string}
     * @memberof CompositionJsonldRead
     */
    'representantId'?: string;
    /**
     * Get the value of actif
     * @type {boolean}
     * @memberof CompositionJsonldRead
     */
    'actif'?: boolean;
    /**
     * Get the value of nom
     * @type {string}
     * @memberof CompositionJsonldRead
     */
    'nom'?: string;
    /**
     * Get the value of nomUsage
     * @type {string}
     * @memberof CompositionJsonldRead
     */
    'nomUsage'?: string;
    /**
     * Get the value of prenoms
     * @type {string}
     * @memberof CompositionJsonldRead
     */
    'prenoms'?: string;
    /**
     * Get the value of nationalite
     * @type {string}
     * @memberof CompositionJsonldRead
     */
    'nationalite'?: string;
    /**
     * Get the value of detentionPartDirect
     * @type {boolean}
     * @memberof CompositionJsonldRead
     */
    'detentionPartDirect'?: boolean;
    /**
     * Get the value of detentionPartIndirect
     * @type {boolean}
     * @memberof CompositionJsonldRead
     */
    'detentionPartIndirect'?: boolean;
    /**
     * Get the value of partTotale
     * @type {number}
     * @memberof CompositionJsonldRead
     */
    'partTotale'?: number;
    /**
     * Get the value of modalitesDeControle
     * @type {Array<string>}
     * @memberof CompositionJsonldRead
     */
    'modalitesDeControle'?: Array<string>;
    /**
     * Get the value of roleEntreprise
     * @type {string}
     * @memberof CompositionJsonldRead
     */
    'roleEntreprise'?: string;
    /**
     * Get the value of libelleRoleEntreprise
     * @type {string}
     * @memberof CompositionJsonldRead
     */
    'libelleRoleEntreprise'?: string;
    /**
     * Get the value of typePersonne
     * @type {string}
     * @memberof CompositionJsonldRead
     */
    'typePersonne'?: string;
    /**
     * Get the value of typePersonneRef
     * @type {string}
     * @memberof CompositionJsonldRead
     */
    'typePersonneRef'?: string;
    /**
     * Get the value of genreRef
     * @type {number}
     * @memberof CompositionJsonldRead
     */
    'genreRef'?: number;
    /**
     * Get the value of genreRne
     * @type {string}
     * @memberof CompositionJsonldRead
     */
    'genreRne'?: string;
    /**
     * Get the value of codeNat
     * @type {string}
     * @memberof CompositionJsonldRead
     */
    'codeNat'?: string;
    /**
     * Get the value of siren
     * @type {string}
     * @memberof CompositionJsonldRead
     */
    'siren'?: string;
    /**
     * Get the value of formeJuridique
     * @type {number}
     * @memberof CompositionJsonldRead
     */
    'formeJuridique'?: number;
    /**
     * Get the value of libelleFormeJuridique
     * @type {string}
     * @memberof CompositionJsonldRead
     */
    'libelleFormeJuridique'?: string;
    /**
     * Get the value of stdFormeJuridique
     * @type {string}
     * @memberof CompositionJsonldRead
     */
    'stdFormeJuridique'?: string;
    /**
     * Get the value of stdLibelleFormeJuridique
     * @type {string}
     * @memberof CompositionJsonldRead
     */
    'stdLibelleFormeJuridique'?: string;
    /**
     * Get the value of denomination
     * @type {string}
     * @memberof CompositionJsonldRead
     */
    'denomination'?: string;
    /**
     * Get the value of genreLibelle
     * @type {string}
     * @memberof CompositionJsonldRead
     */
    'genreLibelle'?: string;
    /**
     * Get the value of lieuRegistre
     * @type {string}
     * @memberof CompositionJsonldRead
     */
    'lieuRegistre'?: string;
    /**
     * Get the value of address
     * @type {object}
     * @memberof CompositionJsonldRead
     */
    'address'?: object;
    /**
     * Get the value of dateDeNaissance
     * @type {string}
     * @memberof CompositionJsonldRead
     */
    'dateDeNaissance'?: string;
    /**
     * Get the value of modalite
     * @type {string}
     * @memberof CompositionJsonldRead
     */
    'modalite'?: string;
    /**
     * Get the value of situationMatrimonialeConjoint
     * @type {string}
     * @memberof CompositionJsonldRead
     */
    'situationMatrimonialeConjoint'?: string;
    /**
     * Get the value of civilite
     * @type {number}
     * @memberof CompositionJsonldRead
     */
    'civilite'?: number;
    /**
     * Get the value of civiliteLibelle
     * @type {string}
     * @memberof CompositionJsonldRead
     */
    'civiliteLibelle'?: string;
}
/**
 * 
 * @export
 * @interface CompositionRead
 */
export interface CompositionRead {
    /**
     * Get the value of beneficiaireId
     * @type {string}
     * @memberof CompositionRead
     */
    'beneficiaireId'?: string;
    /**
     * Get the value of representantId
     * @type {string}
     * @memberof CompositionRead
     */
    'representantId'?: string;
    /**
     * Get the value of actif
     * @type {boolean}
     * @memberof CompositionRead
     */
    'actif'?: boolean;
    /**
     * Get the value of nom
     * @type {string}
     * @memberof CompositionRead
     */
    'nom'?: string;
    /**
     * Get the value of nomUsage
     * @type {string}
     * @memberof CompositionRead
     */
    'nomUsage'?: string;
    /**
     * Get the value of prenoms
     * @type {string}
     * @memberof CompositionRead
     */
    'prenoms'?: string;
    /**
     * Get the value of nationalite
     * @type {string}
     * @memberof CompositionRead
     */
    'nationalite'?: string;
    /**
     * Get the value of detentionPartDirect
     * @type {boolean}
     * @memberof CompositionRead
     */
    'detentionPartDirect'?: boolean;
    /**
     * Get the value of detentionPartIndirect
     * @type {boolean}
     * @memberof CompositionRead
     */
    'detentionPartIndirect'?: boolean;
    /**
     * Get the value of partTotale
     * @type {number}
     * @memberof CompositionRead
     */
    'partTotale'?: number;
    /**
     * Get the value of modalitesDeControle
     * @type {Array<string>}
     * @memberof CompositionRead
     */
    'modalitesDeControle'?: Array<string>;
    /**
     * Get the value of roleEntreprise
     * @type {string}
     * @memberof CompositionRead
     */
    'roleEntreprise'?: string;
    /**
     * Get the value of libelleRoleEntreprise
     * @type {string}
     * @memberof CompositionRead
     */
    'libelleRoleEntreprise'?: string;
    /**
     * Get the value of typePersonne
     * @type {string}
     * @memberof CompositionRead
     */
    'typePersonne'?: string;
    /**
     * Get the value of typePersonneRef
     * @type {string}
     * @memberof CompositionRead
     */
    'typePersonneRef'?: string;
    /**
     * Get the value of genreRef
     * @type {number}
     * @memberof CompositionRead
     */
    'genreRef'?: number;
    /**
     * Get the value of genreRne
     * @type {string}
     * @memberof CompositionRead
     */
    'genreRne'?: string;
    /**
     * Get the value of codeNat
     * @type {string}
     * @memberof CompositionRead
     */
    'codeNat'?: string;
    /**
     * Get the value of siren
     * @type {string}
     * @memberof CompositionRead
     */
    'siren'?: string;
    /**
     * Get the value of formeJuridique
     * @type {number}
     * @memberof CompositionRead
     */
    'formeJuridique'?: number;
    /**
     * Get the value of libelleFormeJuridique
     * @type {string}
     * @memberof CompositionRead
     */
    'libelleFormeJuridique'?: string;
    /**
     * Get the value of stdFormeJuridique
     * @type {string}
     * @memberof CompositionRead
     */
    'stdFormeJuridique'?: string;
    /**
     * Get the value of stdLibelleFormeJuridique
     * @type {string}
     * @memberof CompositionRead
     */
    'stdLibelleFormeJuridique'?: string;
    /**
     * Get the value of denomination
     * @type {string}
     * @memberof CompositionRead
     */
    'denomination'?: string;
    /**
     * Get the value of genreLibelle
     * @type {string}
     * @memberof CompositionRead
     */
    'genreLibelle'?: string;
    /**
     * Get the value of lieuRegistre
     * @type {string}
     * @memberof CompositionRead
     */
    'lieuRegistre'?: string;
    /**
     * Get the value of address
     * @type {object}
     * @memberof CompositionRead
     */
    'address'?: object;
    /**
     * Get the value of dateDeNaissance
     * @type {string}
     * @memberof CompositionRead
     */
    'dateDeNaissance'?: string;
    /**
     * Get the value of modalite
     * @type {string}
     * @memberof CompositionRead
     */
    'modalite'?: string;
    /**
     * Get the value of situationMatrimonialeConjoint
     * @type {string}
     * @memberof CompositionRead
     */
    'situationMatrimonialeConjoint'?: string;
    /**
     * Get the value of civilite
     * @type {number}
     * @memberof CompositionRead
     */
    'civilite'?: number;
    /**
     * Get the value of civiliteLibelle
     * @type {string}
     * @memberof CompositionRead
     */
    'civiliteLibelle'?: string;
}
/**
 * 
 * @export
 * @interface CompositionWrapperJsonldRead
 */
export interface CompositionWrapperJsonldRead {
    /**
     * 
     * @type {ActiviteJsonldReadContext}
     * @memberof CompositionWrapperJsonldRead
     */
    '@context'?: ActiviteJsonldReadContext;
    /**
     * 
     * @type {string}
     * @memberof CompositionWrapperJsonldRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CompositionWrapperJsonldRead
     */
    '@type'?: string;
    /**
     * Get the value of beneficiaire
     * @type {Array<CompositionJsonldRead>}
     * @memberof CompositionWrapperJsonldRead
     */
    'beneficiaire'?: Array<CompositionJsonldRead>;
    /**
     * Get the value of structure
     * @type {Array<CompositionJsonldRead>}
     * @memberof CompositionWrapperJsonldRead
     */
    'structure'?: Array<CompositionJsonldRead>;
}
/**
 * 
 * @export
 * @interface CompositionWrapperRead
 */
export interface CompositionWrapperRead {
    /**
     * Get the value of beneficiaire
     * @type {Array<CompositionRead>}
     * @memberof CompositionWrapperRead
     */
    'beneficiaire'?: Array<CompositionRead>;
    /**
     * Get the value of structure
     * @type {Array<CompositionRead>}
     * @memberof CompositionWrapperRead
     */
    'structure'?: Array<CompositionRead>;
}
/**
 * 
 * @export
 * @interface EtablissementJsonldRead
 */
export interface EtablissementJsonldRead {
    /**
     * 
     * @type {ActiviteJsonldReadContext}
     * @memberof EtablissementJsonldRead
     */
    '@context'?: ActiviteJsonldReadContext;
    /**
     * 
     * @type {string}
     * @memberof EtablissementJsonldRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof EtablissementJsonldRead
     */
    '@type'?: string;
    /**
     * get Siret number
     * @type {string}
     * @memberof EtablissementJsonldRead
     */
    'siret'?: string;
    /**
     * get Activite
     * @type {string}
     * @memberof EtablissementJsonldRead
     */
    'activite'?: string;
    /**
     * get if company is active
     * @type {boolean}
     * @memberof EtablissementJsonldRead
     */
    'actif'?: boolean;
    /**
     * get date creation company
     * @type {string}
     * @memberof EtablissementJsonldRead
     */
    'dateCreation'?: string;
    /**
     * Get the value of rolePourEntreprise
     * @type {string}
     * @memberof EtablissementJsonldRead
     */
    'rolePourEntreprise'?: string;
    /**
     * Get the value of statutPourFormalite
     * @type {string}
     * @memberof EtablissementJsonldRead
     */
    'statutPourFormalite'?: string;
    /**
     * Get the value of dateEffetFermeture
     * @type {string}
     * @memberof EtablissementJsonldRead
     */
    'dateEffetFermeture'?: string;
    /**
     * Get the value of codeApe
     * @type {string}
     * @memberof EtablissementJsonldRead
     */
    'codeApe'?: string;
    /**
     * Get the value of etablissementRdd
     * @type {boolean}
     * @memberof EtablissementJsonldRead
     */
    'etablissementRdd'?: boolean;
    /**
     * Get the value of indicateurEtablissementPrincipal
     * @type {boolean}
     * @memberof EtablissementJsonldRead
     */
    'indicateurEtablissementPrincipal'?: boolean;
    /**
     * Get the value of address
     * @type {object}
     * @memberof EtablissementJsonldRead
     */
    'address'?: object;
    /**
     * Get the value of aActivite
     * @type {Array<ActiviteJsonldRead>}
     * @memberof EtablissementJsonldRead
     */
    'aActivite'?: Array<ActiviteJsonldRead>;
}
/**
 * 
 * @export
 * @interface EtablissementRead
 */
export interface EtablissementRead {
    /**
     * get Siret number
     * @type {string}
     * @memberof EtablissementRead
     */
    'siret'?: string;
    /**
     * get Activite
     * @type {string}
     * @memberof EtablissementRead
     */
    'activite'?: string;
    /**
     * get if company is active
     * @type {boolean}
     * @memberof EtablissementRead
     */
    'actif'?: boolean;
    /**
     * get date creation company
     * @type {string}
     * @memberof EtablissementRead
     */
    'dateCreation'?: string;
    /**
     * Get the value of rolePourEntreprise
     * @type {string}
     * @memberof EtablissementRead
     */
    'rolePourEntreprise'?: string;
    /**
     * Get the value of statutPourFormalite
     * @type {string}
     * @memberof EtablissementRead
     */
    'statutPourFormalite'?: string;
    /**
     * Get the value of dateEffetFermeture
     * @type {string}
     * @memberof EtablissementRead
     */
    'dateEffetFermeture'?: string;
    /**
     * Get the value of codeApe
     * @type {string}
     * @memberof EtablissementRead
     */
    'codeApe'?: string;
    /**
     * Get the value of etablissementRdd
     * @type {boolean}
     * @memberof EtablissementRead
     */
    'etablissementRdd'?: boolean;
    /**
     * Get the value of indicateurEtablissementPrincipal
     * @type {boolean}
     * @memberof EtablissementRead
     */
    'indicateurEtablissementPrincipal'?: boolean;
    /**
     * Get the value of address
     * @type {object}
     * @memberof EtablissementRead
     */
    'address'?: object;
    /**
     * Get the value of aActivite
     * @type {Array<ActiviteRead>}
     * @memberof EtablissementRead
     */
    'aActivite'?: Array<ActiviteRead>;
}
/**
 * 
 * @export
 * @interface EtablissementsWrapperJsonldRead
 */
export interface EtablissementsWrapperJsonldRead {
    /**
     * 
     * @type {ActiviteJsonldReadContext}
     * @memberof EtablissementsWrapperJsonldRead
     */
    '@context'?: ActiviteJsonldReadContext;
    /**
     * 
     * @type {string}
     * @memberof EtablissementsWrapperJsonldRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof EtablissementsWrapperJsonldRead
     */
    '@type'?: string;
    /**
     * Get the value of principal
     * @type {Array<EtablissementJsonldRead>}
     * @memberof EtablissementsWrapperJsonldRead
     */
    'principal'?: Array<EtablissementJsonldRead>;
    /**
     * Get the value of autres
     * @type {Array<EtablissementJsonldRead>}
     * @memberof EtablissementsWrapperJsonldRead
     */
    'autres'?: Array<EtablissementJsonldRead>;
    /**
     * 
     * @type {Array<EtablissementJsonldRead>}
     * @memberof EtablissementsWrapperJsonldRead
     */
    'suggestions'?: Array<EtablissementJsonldRead>;
}
/**
 * 
 * @export
 * @interface EtablissementsWrapperRead
 */
export interface EtablissementsWrapperRead {
    /**
     * Get the value of principal
     * @type {Array<EtablissementRead>}
     * @memberof EtablissementsWrapperRead
     */
    'principal'?: Array<EtablissementRead>;
    /**
     * Get the value of autres
     * @type {Array<EtablissementRead>}
     * @memberof EtablissementsWrapperRead
     */
    'autres'?: Array<EtablissementRead>;
    /**
     * 
     * @type {Array<EtablissementRead>}
     * @memberof EtablissementsWrapperRead
     */
    'suggestions'?: Array<EtablissementRead>;
}
/**
 * 
 * @export
 * @interface SirenJsonldRead
 */
export interface SirenJsonldRead {
    /**
     * 
     * @type {ActiviteJsonldReadContext}
     * @memberof SirenJsonldRead
     */
    '@context'?: ActiviteJsonldReadContext;
    /**
     * 
     * @type {string}
     * @memberof SirenJsonldRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof SirenJsonldRead
     */
    '@type'?: string;
    /**
     * getSiren
     * @type {string}
     * @memberof SirenJsonldRead
     */
    'siren': string;
    /**
     * 
     * @type {string}
     * @memberof SirenJsonldRead
     */
    'siret': string;
    /**
     * Get the value of id
     * @type {string}
     * @memberof SirenJsonldRead
     */
    'idRne'?: string;
    /**
     * getIsCapitalFix
     * @type {boolean}
     * @memberof SirenJsonldRead
     */
    'isCapitalvariable'?: boolean;
    /**
     * getCapital
     * @type {number}
     * @memberof SirenJsonldRead
     */
    'capital'?: number | null;
    /**
     * Get the value of codeApe
     * @type {string}
     * @memberof SirenJsonldRead
     */
    'codeApe'?: string;
    /**
     * Get the value of dateClotureExerciceSocial
     * @type {string}
     * @memberof SirenJsonldRead
     */
    'dateClotureExerciceSocial'?: string;
    /**
     * Get the value of nicSiege
     * @type {string}
     * @memberof SirenJsonldRead
     */
    'nicSiege'?: string;
    /**
     * Get the value of typePersonne
     * @type {string}
     * @memberof SirenJsonldRead
     */
    'typePersonne'?: string;
    /**
     * Get the value of typePersonneRef
     * @type {number}
     * @memberof SirenJsonldRead
     */
    'typePersonneRef'?: number;
    /**
     * Get the value of dateCreation
     * @type {string}
     * @memberof SirenJsonldRead
     */
    'dateCreation'?: string;
    /**
     * Get the value of societeEtrangere
     * @type {boolean}
     * @memberof SirenJsonldRead
     */
    'societeEtrangere'?: boolean;
    /**
     * Get the value of dateDebutActiv
     * @type {string}
     * @memberof SirenJsonldRead
     */
    'dateDebutActiv'?: string;
    /**
     * Get the value of capitalDisponible
     * @type {boolean}
     * @memberof SirenJsonldRead
     */
    'capitalDisponible'?: boolean;
    /**
     * Get the value of formeJuridique
     * @type {number}
     * @memberof SirenJsonldRead
     */
    'formeJuridique'?: number;
    /**
     * Get the value of libelleFormeJuridique
     * @type {string}
     * @memberof SirenJsonldRead
     */
    'libelleFormeJuridique'?: string;
    /**
     * Get the value of stdFormeJuridique
     * @type {string}
     * @memberof SirenJsonldRead
     */
    'stdFormeJuridique'?: string;
    /**
     * Get the value of stdLibelleFormeJuridique
     * @type {string}
     * @memberof SirenJsonldRead
     */
    'stdLibelleFormeJuridique'?: string;
    /**
     * Get the value of denomination
     * @type {string}
     * @memberof SirenJsonldRead
     */
    'denomination'?: string;
    /**
     * Get the value of nom
     * @type {string}
     * @memberof SirenJsonldRead
     */
    'nom'?: string;
    /**
     * Get the value of prenom
     * @type {string}
     * @memberof SirenJsonldRead
     */
    'prenom'?: string;
    /**
     * Get the value of civilite
     * @type {number}
     * @memberof SirenJsonldRead
     */
    'civilite'?: number;
    /**
     * Get the value of civiliteLibelle
     * @type {string}
     * @memberof SirenJsonldRead
     */
    'civiliteLibelle'?: string;
    /**
     * Get the value of genreRef
     * @type {number}
     * @memberof SirenJsonldRead
     */
    'genreRef'?: number;
    /**
     * Get the value of genreRne
     * @type {string}
     * @memberof SirenJsonldRead
     */
    'genreRne'?: string;
    /**
     * Get the value of genreLibelle
     * @type {string}
     * @memberof SirenJsonldRead
     */
    'genreLibelle'?: string;
    /**
     * Get the value of situationMatrimoniale
     * @type {string}
     * @memberof SirenJsonldRead
     */
    'situationMatrimoniale'?: string;
    /**
     * Get the value of natureGeranceRef
     * @type {number}
     * @memberof SirenJsonldRead
     */
    'natureGeranceRef'?: number;
    /**
     * Get the value of natureGeranceLibelle
     * @type {string}
     * @memberof SirenJsonldRead
     */
    'natureGeranceLibelle'?: string;
    /**
     * getEtablissements
     * @type {EtablissementsWrapperJsonldRead}
     * @memberof SirenJsonldRead
     */
    'etablissements'?: EtablissementsWrapperJsonldRead;
    /**
     * getComposition
     * @type {CompositionWrapperJsonldRead}
     * @memberof SirenJsonldRead
     */
    'composition'?: CompositionWrapperJsonldRead;
    /**
     * Get the value of source
     * @type {string}
     * @memberof SirenJsonldRead
     */
    'source'?: string | null;
}
/**
 * 
 * @export
 * @interface SirenRead
 */
export interface SirenRead {
    /**
     * getSiren
     * @type {string}
     * @memberof SirenRead
     */
    'siren': string;
    /**
     * 
     * @type {string}
     * @memberof SirenRead
     */
    'siret': string;
    /**
     * Get the value of id
     * @type {string}
     * @memberof SirenRead
     */
    'idRne'?: string;
    /**
     * getIsCapitalFix
     * @type {boolean}
     * @memberof SirenRead
     */
    'isCapitalvariable'?: boolean;
    /**
     * getCapital
     * @type {number}
     * @memberof SirenRead
     */
    'capital'?: number | null;
    /**
     * Get the value of codeApe
     * @type {string}
     * @memberof SirenRead
     */
    'codeApe'?: string;
    /**
     * Get the value of dateClotureExerciceSocial
     * @type {string}
     * @memberof SirenRead
     */
    'dateClotureExerciceSocial'?: string;
    /**
     * Get the value of nicSiege
     * @type {string}
     * @memberof SirenRead
     */
    'nicSiege'?: string;
    /**
     * Get the value of typePersonne
     * @type {string}
     * @memberof SirenRead
     */
    'typePersonne'?: string;
    /**
     * Get the value of typePersonneRef
     * @type {number}
     * @memberof SirenRead
     */
    'typePersonneRef'?: number;
    /**
     * Get the value of dateCreation
     * @type {string}
     * @memberof SirenRead
     */
    'dateCreation'?: string;
    /**
     * Get the value of societeEtrangere
     * @type {boolean}
     * @memberof SirenRead
     */
    'societeEtrangere'?: boolean;
    /**
     * Get the value of dateDebutActiv
     * @type {string}
     * @memberof SirenRead
     */
    'dateDebutActiv'?: string;
    /**
     * Get the value of capitalDisponible
     * @type {boolean}
     * @memberof SirenRead
     */
    'capitalDisponible'?: boolean;
    /**
     * Get the value of formeJuridique
     * @type {number}
     * @memberof SirenRead
     */
    'formeJuridique'?: number;
    /**
     * Get the value of libelleFormeJuridique
     * @type {string}
     * @memberof SirenRead
     */
    'libelleFormeJuridique'?: string;
    /**
     * Get the value of stdFormeJuridique
     * @type {string}
     * @memberof SirenRead
     */
    'stdFormeJuridique'?: string;
    /**
     * Get the value of stdLibelleFormeJuridique
     * @type {string}
     * @memberof SirenRead
     */
    'stdLibelleFormeJuridique'?: string;
    /**
     * Get the value of denomination
     * @type {string}
     * @memberof SirenRead
     */
    'denomination'?: string;
    /**
     * Get the value of nom
     * @type {string}
     * @memberof SirenRead
     */
    'nom'?: string;
    /**
     * Get the value of prenom
     * @type {string}
     * @memberof SirenRead
     */
    'prenom'?: string;
    /**
     * Get the value of civilite
     * @type {number}
     * @memberof SirenRead
     */
    'civilite'?: number;
    /**
     * Get the value of civiliteLibelle
     * @type {string}
     * @memberof SirenRead
     */
    'civiliteLibelle'?: string;
    /**
     * Get the value of genreRef
     * @type {number}
     * @memberof SirenRead
     */
    'genreRef'?: number;
    /**
     * Get the value of genreRne
     * @type {string}
     * @memberof SirenRead
     */
    'genreRne'?: string;
    /**
     * Get the value of genreLibelle
     * @type {string}
     * @memberof SirenRead
     */
    'genreLibelle'?: string;
    /**
     * Get the value of situationMatrimoniale
     * @type {string}
     * @memberof SirenRead
     */
    'situationMatrimoniale'?: string;
    /**
     * Get the value of natureGeranceRef
     * @type {number}
     * @memberof SirenRead
     */
    'natureGeranceRef'?: number;
    /**
     * Get the value of natureGeranceLibelle
     * @type {string}
     * @memberof SirenRead
     */
    'natureGeranceLibelle'?: string;
    /**
     * getEtablissements
     * @type {EtablissementsWrapperRead}
     * @memberof SirenRead
     */
    'etablissements'?: EtablissementsWrapperRead;
    /**
     * getComposition
     * @type {CompositionWrapperRead}
     * @memberof SirenRead
     */
    'composition'?: CompositionWrapperRead;
    /**
     * Get the value of source
     * @type {string}
     * @memberof SirenRead
     */
    'source'?: string | null;
}

/**
 * ComparaisonKbisRneApi - axios parameter creator
 * @export
 */
export const ComparaisonKbisRneApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Retrieves a ComparaisonKbisRne resource.
         * @summary Retrieves a ComparaisonKbisRne resource.
         * @param {string} siren Numéro SIREN à 9 chiffres
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        compareKbisRne: async (siren: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'siren' is not null or undefined
            assertParamExists('compareKbisRne', 'siren', siren)
            const localVarPath = `/siren/comparaison_kbis_rne/{siren}`
                .replace(`{${"siren"}}`, encodeURIComponent(String(siren)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ComparaisonKbisRneApi - functional programming interface
 * @export
 */
export const ComparaisonKbisRneApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ComparaisonKbisRneApiAxiosParamCreator(configuration)
    return {
        /**
         * Retrieves a ComparaisonKbisRne resource.
         * @summary Retrieves a ComparaisonKbisRne resource.
         * @param {string} siren Numéro SIREN à 9 chiffres
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async compareKbisRne(siren: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ComparaisonKbisRneJsonld>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.compareKbisRne(siren, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ComparaisonKbisRneApi.compareKbisRne']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ComparaisonKbisRneApi - factory interface
 * @export
 */
export const ComparaisonKbisRneApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ComparaisonKbisRneApiFp(configuration)
    return {
        /**
         * Retrieves a ComparaisonKbisRne resource.
         * @summary Retrieves a ComparaisonKbisRne resource.
         * @param {ComparaisonKbisRneApiCompareKbisRneRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        compareKbisRne(requestParameters: ComparaisonKbisRneApiCompareKbisRneRequest, options?: RawAxiosRequestConfig): AxiosPromise<ComparaisonKbisRneJsonld> {
            return localVarFp.compareKbisRne(requestParameters.siren, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for compareKbisRne operation in ComparaisonKbisRneApi.
 * @export
 * @interface ComparaisonKbisRneApiCompareKbisRneRequest
 */
export interface ComparaisonKbisRneApiCompareKbisRneRequest {
    /**
     * Numéro SIREN à 9 chiffres
     * @type {string}
     * @memberof ComparaisonKbisRneApiCompareKbisRne
     */
    readonly siren: string
}

/**
 * ComparaisonKbisRneApi - object-oriented interface
 * @export
 * @class ComparaisonKbisRneApi
 * @extends {BaseAPI}
 */
export class ComparaisonKbisRneApi extends BaseAPI {
    /**
     * Retrieves a ComparaisonKbisRne resource.
     * @summary Retrieves a ComparaisonKbisRne resource.
     * @param {ComparaisonKbisRneApiCompareKbisRneRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComparaisonKbisRneApi
     */
    public compareKbisRne(requestParameters: ComparaisonKbisRneApiCompareKbisRneRequest, options?: RawAxiosRequestConfig) {
        return ComparaisonKbisRneApiFp(this.configuration).compareKbisRne(requestParameters.siren, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SirenApi - axios parameter creator
 * @export
 */
export const SirenApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Retrieves a Siren resource.
         * @summary Récupérer information par siren ou par siret
         * @param {string} siren Siren identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRcsSirenGet: async (siren: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'siren' is not null or undefined
            assertParamExists('apiRcsSirenGet', 'siren', siren)
            const localVarPath = `/siren/rcs/{siren}`
                .replace(`{${"siren"}}`, encodeURIComponent(String(siren)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SirenApi - functional programming interface
 * @export
 */
export const SirenApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SirenApiAxiosParamCreator(configuration)
    return {
        /**
         * Retrieves a Siren resource.
         * @summary Récupérer information par siren ou par siret
         * @param {string} siren Siren identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiRcsSirenGet(siren: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SirenJsonldRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiRcsSirenGet(siren, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SirenApi.apiRcsSirenGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SirenApi - factory interface
 * @export
 */
export const SirenApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SirenApiFp(configuration)
    return {
        /**
         * Retrieves a Siren resource.
         * @summary Récupérer information par siren ou par siret
         * @param {SirenApiApiRcsSirenGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRcsSirenGet(requestParameters: SirenApiApiRcsSirenGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<SirenJsonldRead> {
            return localVarFp.apiRcsSirenGet(requestParameters.siren, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiRcsSirenGet operation in SirenApi.
 * @export
 * @interface SirenApiApiRcsSirenGetRequest
 */
export interface SirenApiApiRcsSirenGetRequest {
    /**
     * Siren identifier
     * @type {string}
     * @memberof SirenApiApiRcsSirenGet
     */
    readonly siren: string
}

/**
 * SirenApi - object-oriented interface
 * @export
 * @class SirenApi
 * @extends {BaseAPI}
 */
export class SirenApi extends BaseAPI {
    /**
     * Retrieves a Siren resource.
     * @summary Récupérer information par siren ou par siret
     * @param {SirenApiApiRcsSirenGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SirenApi
     */
    public apiRcsSirenGet(requestParameters: SirenApiApiRcsSirenGetRequest, options?: RawAxiosRequestConfig) {
        return SirenApiFp(this.configuration).apiRcsSirenGet(requestParameters.siren, options).then((request) => request(this.axios, this.basePath));
    }
}



